import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection,AngularFirestoreDocument } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';
import { BehaviorSubject, Observable,Subscription } from 'rxjs';
import { Events} from 'ionic-angular';
import { first } from 'rxjs/operators';
import { User } from  '../../models/user';
import { Storage } from '@ionic/storage';
import { map } from 'rxjs/operators';
import { DataProvider } from '../data/data';
import { HttpClient } from '@angular/common/http';
import { firestore } from 'firebase';
import { LabelProvider } from '../../providers/label/label';
import { environment } from '../../environments/environment';
import { escapeIdentifier } from '@angular/compiler/src/output/abstract_emitter';
const CLOUD_FUNC_URL = environment.cloudUrl;
/*
  Generated class for the AuditProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AuditProvider {
 
  auditsCollection: AngularFirestoreCollection<any>;
  audits$:Observable<any[]>;
  audits:Array<any>;
  auditsSubs:Subscription;
  public questionIndex$: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  questionIndex:number;


  constructor(private afs: AngularFirestore,private storage: Storage, public events:Events,private http: HttpClient, private dataProvider:DataProvider,private fbStorage: AngularFireStorage,public lp :LabelProvider) {
    //console.log('Hello AuditProvider Provider');
  }

  intializeSubscriptions(){
      this.auditsCollection = this.afs.collection<any>('audits',ref => ref.orderBy('creationDate','asc'));
      this.audits$ = this.auditsCollection.snapshotChanges().pipe(
          map(actions => actions.map(a => {
            const data = a.payload.doc.data() as any;
                    const id = a.payload.doc.id;
                    if(data.schedule && data.schedule.start && data.schedule.start.date){
                      data['schedule']['start']['date'] = data.schedule.start.date.toDate();
                    }
                    if(data.schedule && data.schedule.end && data.schedule.end.date){
                      data['schedule']['end']['date'] = data.schedule.end.date.toDate();
                    }
                    if(data.completionDate){
                      data.completionDate = data.completionDate.toDate();
                    }
                    return { id, ...data };
         })));
    
     this.auditsSubs = this.audits$.subscribe( (audits:any) => {  

            this.audits = audits;

            //console.log("******AUdits");
            //console.log(audits);

            this.events.publish('audit:auditList',this.audits);
     });


      this.events.subscribe('audit:getAudits', () => {

         this.events.publish('audit:auditList',this.audits);

      });

      this.events.subscribe('audit:getAudit', (auditId) => {

         this.getAuditInfo(auditId);
        

      });

       this.events.subscribe('audit:getStartedAudits', () => {

        //console.log("******AUdits started");
        //console.log(this.audits);
       this.events.publish('audit:startedAuditList',this.audits);

      });

       this.events.subscribe('audit:getSpecificAudits', (type,data) => {

         this.getSpecificAudits(type,data);
         

      });

       

      this.events.subscribe('audit:startAudit', (auditId:string) => {

        this.startAudit(auditId);

      });

      this.events.subscribe('audit:getAuditTimeline', (auditId:string) => {

        this.getAuditTimeline(auditId);

      });

      this.events.subscribe('audit:getAuditSections', (auditId:string) => {

        this.getAuditSections(auditId);

      });

  
      this.events.subscribe('audit:getTypeSectionQues', (auditTypeId:string,secId:string) => {

        this.getTypeSectionQues(auditTypeId,secId);

      });

      this.events.subscribe('audit:getSectionQues', (auditId:string,secId:string) => {

        this.getSectionQues(auditId,secId);

      });

       this.events.subscribe('audit:uploadAuditImage', (imgDtls) => {

        this.uploadAuditImage(imgDtls);

     });

        this.events.subscribe('audit:reUploadAuditImage', (imgDtls) => {

        this.reUploadAuditImage(imgDtls);

     });
       


      this.events.subscribe('audit:deleteAuditImage', (imgDtls) => {

        this.deleteAuditImage(imgDtls);

     });

      this.events.subscribe('audit:saveAuditComment', (commentDtls) => {

        this.saveAuditComment(commentDtls);

     });

       this.events.subscribe('audit:getQueImages', (queDtls) => {

        this.getQueImages(queDtls);

     });

       this.events.subscribe('audit:updateQueStatus', (queDtls) => {

        this.updateQueStatus(queDtls);

     });


      this.events.subscribe('audit:updateSectionStats', (secStats) => {

        this.updateSectionStats(secStats);

     });
     

     this.events.subscribe('audit:completeSections', (auditId:string) => {

        this.completeSections(auditId);

     });

     this.events.subscribe('audit:doAction', (auditId:string,key:string,actionIssues:Number) => {

        this.doAction(auditId, key,actionIssues);

     });

     this.events.subscribe('audit:saveSignature', (auditId:string,signature:any) => {

        this.saveSignature(auditId, signature);

     });

     this.events.subscribe('audit:saveSigns', (auditId:string,signs:any) => {

        this.saveSigns(auditId, signs);

     });

     this.events.subscribe('audit:verifyActionPlan', (auditId:string,actionIssues:number) => {

        this.verifyActionPlan(auditId,actionIssues);

     });

        this.events.subscribe('audit:getQueDetails', (typeId,sectionId,queId) => {

        this.getQueDetails(typeId,sectionId,queId);

     });

        this.events.subscribe('audit:getSectionFields', (typeId,sectionId) => {

        this.getSectionFields(typeId,sectionId);

     });

        this.events.subscribe('audit:getPriorityList', () => {

        this.getPriorityList();

     });


    this.events.subscribe('audit:generateAuditReportPdf', (auditId,sections,generateGraphs) => {

        this.generateAuditReportPdf(auditId,sections, generateGraphs);

     });

   this.events.subscribe('audit:getAuditReportPdf', (auditId) => {

        this.getAuditReportPdf(auditId);

     });

     this.events.subscribe('audit:getProjects', () => {

        this.getProjects();

     });

     this.events.subscribe('audit:getProjectDealers', (projectId) => {

        this.getProjectDealers(projectId);

     });

       this.events.subscribe('audit:getProjectDealerAudits', (projectId, dealer) => {

        this.getProjectDealerAudits(projectId, dealer);

     });

      this.events.subscribe('audit:getProject', (projectId) => {

        this.getProject(projectId);

     });

      this.events.subscribe('audit:askForActionPlan', (auditId,timelineId) => {

        this.askForActionPlan(auditId,timelineId);

     });

     this.events.subscribe('audit:startActionPlan', (auditId,timelineId,actionIssues) => {

        this.startActionPlan(auditId,timelineId,actionIssues);

     });


     this.events.subscribe('audit:completeAudit', (auditId,timelineId) => {

        this.completeAudit(auditId,timelineId);

     });

      this.events.subscribe('audit:getRatings', () => {

        this.getRatings();

     });


     this.events.subscribe('audit:getAdminApprovalAudits', () => {

      this.getAdminApprovalAudits();

   });
   this.events.subscribe('audit:recordAuditChanges', (auditId, approval, data) => {

    this.recordAuditChanges(auditId, approval, data);

 });

 this.events.subscribe('audit:getApprovalChanges', (auditId, approval) => {

  this.getApprovalChanges(auditId, approval);

});

this.events.subscribe('audit:startAuditApproval', (auditId,approver) => {

  this.startAuditApproval(auditId,approver);

});




   
  }

   removeSubscriptions(){
    if(this.auditsSubs){
           this.auditsSubs.unsubscribe();
    }
    this.events.unsubscribe('audit:getAudits');
     this.events.unsubscribe('audit:getAudit');
    this.events.unsubscribe('audit:getStartedAudits');
    this.events.unsubscribe('audit:getSpecificAudits');
    this.events.unsubscribe('audit:startAudit');
    this.events.unsubscribe('audit:getAuditTimeline');
    this.events.unsubscribe('audit:getAuditSections');
    this.events.unsubscribe('audit:getTypeSectionQues');
    this.events.unsubscribe('audit:getSectionQues');
    this.events.unsubscribe('audit:uploadAuditImage');
    this.events.unsubscribe('audit:reUploadAuditImage');
    this.events.unsubscribe('audit:saveAuditComment');
    this.events.unsubscribe('audit:getQueImages');
    this.events.unsubscribe('audit:updateQueStatus');
    this.events.unsubscribe('audit:updateSectionStats');
    this.events.unsubscribe('audit:completeSections');
    this.events.unsubscribe('audit:doAction');
    this.events.unsubscribe('audit:saveSignature');
    this.events.unsubscribe('audit:saveSigns');
    this.events.unsubscribe('audit:getQueDetails');
    this.events.unsubscribe('audit:generateAuditReportPdf');
    this.events.unsubscribe('audit:getAuditReportPdf');
    this.events.unsubscribe('audit:getProjects');
     this.events.unsubscribe('audit:getProjectDealers');
    this.events.unsubscribe('audit:getProjectDealerAudits');
    this.events.unsubscribe('audit:getProject');
    this.events.unsubscribe('audit:askForActionPlan');
    this.events.unsubscribe('audit:startActionPlan');
    this.events.unsubscribe('audit:completeAudit');
    this.events.unsubscribe('audit:getRatings');
    this.events.unsubscribe('audit:getAdminApprovalAudits');
    this.events.unsubscribe('audit:recordAuditChanges');
    this.events.unsubscribe('audit:getApprovalChanges');
    this.events.unsubscribe('audit:startAuditApproval');
  }


  async getAuditInfo(auditId){

      const audit:any = await this.afs.collection('audits').doc(auditId).valueChanges().pipe(first()).toPromise();
       audit.id = auditId;

         if(audit.schedule && audit.schedule.start && audit.schedule.start.date){
                      audit['schedule']['start']['date'] = audit.schedule.start.date.toDate();
                  }
                    if(audit.schedule && audit.schedule.end && audit.schedule.end.date){
                      audit['schedule']['end']['date'] = audit.schedule.end.date.toDate();
                    }
                    if(audit.completionDate){
                      audit.completionDate = audit.completionDate.toDate();
                    }
     

       this.events.publish('audit:auditInfo',audit);
  }


  async getStartedAudits(){
     const audits = await this.afs.collection('audits').snapshotChanges().pipe(
                  map(actions => actions.map(a => {
                    const data = a.payload.doc.data() as any;
                    const id = a.payload.doc.id;
                    if(data.schedule && data.schedule.start && data.schedule.start.date){
                      data['schedule']['start']['date'] = data.schedule.start.date.toDate();
                    }
                    if(data.schedule && data.schedule.end && data.schedule.end.date){
                      data['schedule']['end']['date'] = data.schedule.end.date.toDate();
                    }
                    if(data.completionDate){
                      data.completionDate = data.completionDate.toDate();
                    }
                    return { id, ...data };
    }))).pipe(first()).toPromise();
    this.events.publish('audit:startedAuditList',audits);
  }

  async getSpecificAudits(type,data){
    let audits = [];
     if(type == 'oem' && this.dataProvider.user.uid){

          //console.log(this.dataProvider.user.uid);

          const dealers = await this.afs.collection('dealership',ref => ref.where('oemFieldRep', '==', this.dataProvider.user.uid)).snapshotChanges().pipe(
                      map(actions => actions.map(a => {
                        const data = a.payload.doc.data() as any;
                        const id = a.payload.doc.id;
                        return { id, ...data };
          }))).pipe(first()).toPromise();
         
         //console.log("dealers");
         //console.log(dealers);

         if(dealers){
              dealers.forEach(async (dealer) => {

                  let dealerAudits = await this.afs.collection('audits',ref => ref.where('dealer.id', '==', dealer.id)).snapshotChanges().pipe(
                          map(actions => actions.map(a => {
                            const data = a.payload.doc.data() as any;
                            const id = a.payload.doc.id;
                            if(data.schedule && data.schedule.start && data.schedule.start.date){
                              data['schedule']['start']['date'] = data.schedule.start.date.toDate();
                            }
                            if(data.schedule && data.schedule.end && data.schedule.end.date){
                              data['schedule']['end']['date'] = data.schedule.end.date.toDate();
                            }
                            if(data.completionDate){
                              data.completionDate = data.completionDate.toDate();
                            }
                            return { id, ...data };
                }))).pipe(first()).toPromise();

                dealerAudits.forEach(audit => {
                     audits.push(audit);
                })
               

             });

            audits.sort(function(a,b){
                if(a < b){
                  return 1;
                }
                else{
                  return -1;
                }
            });
          
            this.events.publish('audit:specificAudits',audits);
         }
        
     }
     else if(type == 'deal' && this.dataProvider.user.uid){

         //console.log(this.dataProvider.user.uid);

         const dealers = await this.afs.collection('dealership',ref => ref.where('principal.id', '==', this.dataProvider.user.uid)).snapshotChanges().pipe(
                      map(actions => actions.map(a => {
                        const data = a.payload.doc.data() as any;
                        const id = a.payload.doc.id;
                        return { id, ...data };
          }))).pipe(first()).toPromise();
         
         //console.log("dealership dealers");
         //console.log(dealers);

         if(dealers){
              dealers.forEach(async (dealer) => {

                  let dealerAudits = await this.afs.collection('audits',ref => ref.where('dealer.id', '==', dealer.id)).snapshotChanges().pipe(
                          map(actions => actions.map(a => {
                            const data = a.payload.doc.data() as any;
                            const id = a.payload.doc.id;
                            if(data.schedule && data.schedule.start && data.schedule.start.date){
                              data['schedule']['start']['date'] = data.schedule.start.date.toDate();
                            }
                            if(data.schedule && data.schedule.end && data.schedule.end.date){
                              data['schedule']['end']['date'] = data.schedule.end.date.toDate();
                            }
                            if(data.completionDate){
                              data.completionDate = data.completionDate.toDate();
                            }
                            return { id, ...data };
                }))).pipe(first()).toPromise();

                dealerAudits.forEach(audit => {
                     audits.push(audit);
                })
               

             });

            audits.sort(function(a,b){
                if(a < b){
                  return 1;
                }
                else{
                  return -1;
                }
            });
          
            this.events.publish('audit:specificAudits',audits);
         }
     }
     else if(type == 'dmgr' && this.dataProvider.user.uid){

         //console.log(this.dataProvider.user.uid);

      

          let audits = await this.afs.collection('audits',ref => ref.where('dealer.manager.id', '==', this.dataProvider.user.uid).orderBy('creationDate','desc')).snapshotChanges().pipe(
                          map(actions => actions.map(a => {
                            const data = a.payload.doc.data() as any;
                            const id = a.payload.doc.id;
                            if(data.schedule && data.schedule.start && data.schedule.start.date){
                              data['schedule']['start']['date'] = data.schedule.start.date.toDate();
                            }
                            if(data.schedule && data.schedule.end && data.schedule.end.date){
                              data['schedule']['end']['date'] = data.schedule.end.date.toDate();
                            }
                            if(data.completionDate){
                              data.completionDate = data.completionDate.toDate();
                            }
                            return { id, ...data };
            }))).pipe(first()).toPromise();

               
          
            this.events.publish('audit:specificAudits',audits);
        
     }
  }
  async startAudit(auditId){
    try {
      await this.afs.collection('audits').doc(auditId).update({'status':{id:1,name:"In Progress"},'startedAt':new Date()});
      await this.afs.collection('audits').doc(auditId).collection('timeline').add({
        type:"info",
        message:this.lp.labels['AUDIT_STARTED_TIMELINE_MSG'],
        key:'audit_started',
        user:{
          id:this.dataProvider.user && this.dataProvider.user.uid ? this.dataProvider.user.uid : null,
          name:this.dataProvider.user && this.dataProvider.user.name ? this.dataProvider.user.name : null
        },
        active:true,
        creationDate:new Date()

      });
      await this.afs.collection('audits').doc(auditId).collection('timeline').add({
        type:"sections",
        message:this.lp.labels['COMPLETE_AUDIT_SECTIONS_TIMELINE_MSG'],
        key:'complete_sections',
        active:true,
        creationDate:new Date()

      });
      await this.afs.collection('audits').doc(auditId).update({'status.state':'complete_sections'});
      this.events.publish('audit:auditStartSuccess');
    }
    catch(error){
      this.events.publish('audit:auditStartFailed');
    }
    
  }

  async getAuditTimeline(auditId){
    //console.log('auditId', auditId)
     const auditTimeline = await this.afs.collection('audits').doc(auditId).collection('timeline',ref => ref.where('active', '==', true).orderBy('creationDate','desc')).snapshotChanges().pipe(
                  map(actions => actions.map(a => {
                    const data = a.payload.doc.data() as any;
                    const id = a.payload.doc.id;
                    if(data.creationDate){
                      data.creationDate = data.creationDate.toDate();
                    }
                    return { id, ...data };
    }))).pipe(first()).toPromise();
     //console.log(auditTimeline);
    this.events.publish('audit:auditTimeline',auditTimeline);
  }

  async getAuditSections(auditId){
    //console.log('auditId', auditId)
    const auditSections = await this.afs.collection('audits').doc(auditId).collection('sections',ref => ref.orderBy('order')).snapshotChanges().pipe(
                  map(actions => actions.map(a => {
                    const data = a.payload.doc.data() as any;
                    return data;
    }))).pipe(first()).toPromise();
     //console.log(auditSections);
    this.events.publish('audit:auditSections',auditSections);
  }

 

  async getTypeSectionQues(auditTypeId,secId){

    const typeSectionQues = await this.afs.collection('audtypes').doc(auditTypeId).collection('sections').doc(secId).collection('questions',ref => ref.orderBy('order').where('active', '==', true)).snapshotChanges().pipe(
                  map(actions => actions.map(a => {
                    const data = a.payload.doc.data() as any;
                    const id = a.payload.doc.id;
                    return { id, ...data };
    }))).pipe(first()).toPromise();
    
    this.events.publish('audit:typeSectionQues',typeSectionQues,secId);

  }

  async getSectionQues(auditId,secId){
    //console.log('audit.ts:  this.questionIndex')
    //console.log(auditId)
    //console.log(secId)
    // //console.log(secId)
    const sectionQues = await this.afs.collection('audits').doc(auditId).collection('sections').doc(secId).collection('questions').snapshotChanges().pipe(
                  map(actions => actions.map(a => {
                    const data = a.payload.doc.data() as any;
                    return data;
    }))).pipe(first()).toPromise();
    
    this.events.publish('audit:sectionQues',sectionQues,secId);
    //console.log('sectionQues', sectionQues)
    return sectionQues;
   
  }

   async reUploadAuditImage(imgDtls){

                 
                   
                   const path = 'audits/'+imgDtls.auditId+'/sections/'+imgDtls.sectionId+'/questions/'+imgDtls.queId+'/images/'+imgDtls.id+'.png';
                   const imgRef = this.fbStorage.ref(path);

                   await imgRef.putString(imgDtls.image,'data_url');
                   const downloadURL = await imgRef.getDownloadURL().pipe(first()).toPromise();
                   await this.afs.collection('audits').doc(imgDtls.auditId).collection('sections').doc(imgDtls.sectionId).collection('questions').doc(imgDtls.queId).collection('images').doc(imgDtls.id).update({url:downloadURL,uploadedAt:new Date()});
                   this.events.publish('audit:auditImage',{id:imgDtls.id,url:downloadURL,queId:imgDtls.queId,index:imgDtls.index});
                   this.events.publish('audit:getAuditSections',imgDtls.auditId);
   }

  async uploadAuditImage(imgDtls){

                 const imgDoc = await this.afs.collection('audits').doc(imgDtls.auditId).collection('sections').doc(imgDtls.sectionId).collection('questions').doc(imgDtls.queId).collection('images').add({uploadedAt:new Date()});
                 if(imgDoc && imgDoc.id){
                   this.events.publish('audit:auditImageId',{id:imgDoc.id,queId:imgDtls.queId,index:imgDtls.index});
                   const path = 'audits/'+imgDtls.auditId+'/sections/'+imgDtls.sectionId+'/questions/'+imgDtls.queId+'/images/'+imgDoc.id+'.png';
                   const imgRef = this.fbStorage.ref(path);

                   await imgRef.putString(imgDtls.image,'data_url');

                   const downloadURL = await imgRef.getDownloadURL().pipe(first()).toPromise();

                   await this.afs.collection('audits').doc(imgDtls.auditId).collection('sections').doc(imgDtls.sectionId).collection('questions').doc(imgDtls.queId).collection('images').doc(imgDoc.id).update({url:downloadURL,uploadedAt:new Date()});
                  
                   this.events.publish('audit:auditImage',{id:imgDoc.id,url:downloadURL,queId:imgDtls.queId,index:imgDtls.index});

                 }

                 this.events.publish('audit:getAuditSections',imgDtls.auditId);
   }

 async deleteAuditImage(imgDtls){
     
     const path = 'audits/'+imgDtls.auditId+'sections/'+imgDtls.sectionId+'questions/'+imgDtls.queId+'/images/'+imgDtls.imageId+'.png';
     const imgRef = this.fbStorage.ref(path);
     await imgRef.delete();
     await this.afs.collection('audits').doc(imgDtls.auditId).collection('sections').doc(imgDtls.sectionId).collection('questions').doc(imgDtls.queId).collection('images').doc(imgDtls.imageId).delete();
 }

  async saveAuditComment(commDtls){
      await this.afs.collection('audits').doc(commDtls.auditId).collection('sections').doc(commDtls.sectionId).collection('questions').doc(commDtls.queId).update({comment:commDtls.comment});
      this.events.publish('audit:auditCommentSaved');

      this.events.publish('audit:getAuditSections',commDtls.auditId);
  }

  async getQueImages(queDtls){
    const queImages = await this.afs.collection('audits').doc(queDtls.auditId).collection('sections').doc(queDtls.sectionId).collection('questions').doc(queDtls.queId).collection('images').snapshotChanges().pipe(
                  map(actions => actions.map(a => {
                    const data = a.payload.doc.data() as any;
                     const id = a.payload.doc.id;
                    return { id, ...data };
    }))).pipe(first()).toPromise();
     //console.log(queImages);
    this.events.publish('audit:queImages',queDtls.queId,queDtls.sectionId,queImages);
  }

  async updateQueStatus(queDtls){
    //console.log('queDtls')
      //console.log(queDtls);
      await this.afs.collection('audits').doc(queDtls.auditId).collection('sections').doc(queDtls.sectionId).collection('questions').doc(queDtls.queId).update({status:queDtls.status, answeredQuestion: queDtls.answeredQuestion,id: queDtls.id, isCompleted : true});
      this.events.publish('audit:queStatusUpdated');
  }

  async updateSectionStats(secStats){
    //console.log('secStats--->', secStats)
    await this.afs.collection('audits').doc(secStats.auditId).collection('sections').doc(secStats.sectionId).update({isCompleted:secStats.isCompleted,progress:secStats.progress});
    this.events.publish('audit:secStatsUpdated');

    setTimeout(() => {
      this.events.publish('audit:getAuditSections',secStats.auditId);
    },2000);
    
  }

  async hideTimelineEvent(auditId,key){
    let timelineDocs =  await this.afs.collection('audits').doc(auditId).collection('timeline', ref => ref.where('key', '==', key)).snapshotChanges().pipe(
                  map(actions => actions.map(a => {
                    const data = a.payload.doc.data() as any;
                    const id = a.payload.doc.id;
                    if(data.creationDate){
                      data.creationDate = data.creationDate.toDate();
                    }
                    return { id, ...data };
     }))).pipe(first()).toPromise();

    if(timelineDocs){
        timelineDocs.forEach(async(doc) => {
          if(doc.key == key){
            await this.afs.collection('audits').doc(auditId).collection('timeline').doc(doc.id).update({active:false});
          }
        });
     }
  }

  async completeSections(auditId){

        await this.afs.collection('audits').doc(auditId).collection('timeline').add({
          type:"sections",
          message:this.lp.labels['SECTIONS_COMPLETED_TIMELINE_MSG'],
          key:'sections_completed',
          active:true,
          creationDate:new Date()
        });
       await this.afs.collection('audits').doc(auditId).collection('timeline').add({
        type:"action",
        message:this.lp.labels['FINISH_AUDIT_TIMELINE_QUE'],
        btn_text:this.lp.labels['FINSIH_AUDIT_TIMELINE_BTN'],
        key:'finish_audit',
        user:{
          id:this.dataProvider.user && this.dataProvider.user.uid ? this.dataProvider.user.uid : null,
          name:this.dataProvider.user && this.dataProvider.user.name ? this.dataProvider.user.name : null
        },
        active:true,
        creationDate:new Date()

      });
    
      this.hideTimelineEvent(auditId,'complete_sections');

      await this.afs.collection('audits').doc(auditId).update({'status.state':'sections_completed'});
       setTimeout(() => {
         // this.events.publish('audit:getAuditTimeline',auditId);
        },1000);
  }

  async doAction(auditId, key, actionIssues){
    if(key == 'finish_audit'){

         await this.afs.collection('actionPlan').doc(auditId).set({count:actionIssues,status:'pending', createdOn:new Date()});
       
      // await this.afs.collection('audits').doc(auditId).update({status:{id:2,name:'In Progress'}});
         await this.afs.collection('audits').doc(auditId).collection('timeline').add({
               type:"info",
                message:this.lp.labels['AUDIT_FINISHED_TIMELINE_MSG'],
                key:'audit_finished',
                user:{
                  id:this.dataProvider.user && this.dataProvider.user.uid ? this.dataProvider.user.uid : null,
                  name:this.dataProvider.user && this.dataProvider.user.name ? this.dataProvider.user.name : null
                },
                active:true,
                creationDate:new Date()
          });

         const audit:any = await this.afs.collection('audits').doc(auditId).valueChanges().pipe(first()).toPromise();
         //console.log("audit sign",audit);
        //  if(audit && audit.signatures){
        //       await this.afs.collection('audits').doc(auditId).collection('timeline').add({
        //       type:"signatures",
        //       message:this.lp.labels['GET_SIGNATURES_TIMELINE_MSG'],
        //       key:'get_signatures',
        //       user:{
        //         id:this.dataProvider.user && this.dataProvider.user.uid ? this.dataProvider.user.uid : null,
        //         name:this.dataProvider.user && this.dataProvider.user.name ? this.dataProvider.user.name : null
        //       },
        //       active:true,
        //       creationDate:new Date()

        //      }); 
        //      await this.afs.collection('audits').doc(auditId).update({'status.state':'get_signatures'});
             

        //  }
        

         await this.afs.collection('audits').doc(auditId).collection('timeline').add({
              type:"action",
              message:this.lp.labels['AUDIT_REPORT_GENERATED_TIMELINE_MSG'],
              btn_text:this.lp.labels['VIEW_AUDIT_REPORT_TIMELINE_BTN'],
              key:'view_report',
              firstVisit:true,
              user:{
               id:this.dataProvider.user && this.dataProvider.user.uid ? this.dataProvider.user.uid : null,
               name:this.dataProvider.user && this.dataProvider.user.name ? this.dataProvider.user.name : null
              },
              active:true,
              creationDate:new Date()
          });

        await this.afs.collection('audits').doc(auditId).update({status:{id:2,name:'Finished',state:'audit_report_generated'}});

        await this.afs.collection('audits').doc(auditId).collection('timeline').add({
             type:"action-plan",
              message:"Action Plan created with "+actionIssues+" action issues.",
              key:'action_plan_created',
              user:{
                id:this.dataProvider.user && this.dataProvider.user.uid ? this.dataProvider.user.uid : null,
                name:this.dataProvider.user && this.dataProvider.user.name ? this.dataProvider.user.name : null
              },
              active:true,
              creationDate:new Date()

        });
         //await this.afs.collection('audits').doc(auditId).update({'status.state':'action_plan_created'});
       
          await this.hideTimelineEvent(auditId,'finish_audit'); 
            this.events.publish('audit:finished'); 
             setTimeout(() => {
              this.events.publish('audit:getAuditTimeline',auditId);
            },1000);
     
      }
      else if(key == 'complete_action_plan'){

          await this.afs.collection('audits').doc(auditId).collection('timeline').add({
               type:"info",
                message:this.lp.labels['ACTION_PLAN_COMPLETED_TIMELINE_MSG'],
                key:'action_plan_completed',
                user:{
                  id:this.dataProvider.user && this.dataProvider.user.uid ? this.dataProvider.user.uid : null,
                  name:this.dataProvider.user && this.dataProvider.user.name ? this.dataProvider.user.name : null
                },
                active:true,
                creationDate:new Date()
         });

          await this.hideTimelineEvent(auditId,'complete_action_plan'); 

        //   await this.afs.collection('audits').doc(auditId).collection('timeline').add({
        //       type:"signoff",
        //       message:this.lp.labels['GET_SIGNOFF_TIMELINE_MSG'],
        //       key:'get_signoff',
        //       user:{
        //         id:this.dataProvider.user && this.dataProvider.user.uid ? this.dataProvider.user.uid : null,
        //         name:this.dataProvider.user && this.dataProvider.user.name ? this.dataProvider.user.name : null
        //       },
        //       active:true,
        //       creationDate:new Date()

        //  }); 
          // await this.afs.collection('audits').doc(auditId).update({'status.state':'get_signoff'});
          this.events.publish('actionPlan:complete', auditId);
           setTimeout(() => {
              this.events.publish('audit:getAuditTimeline',auditId);
            },1000);
          

      }
      else if(key == 'view_report'){

         

        setTimeout(() => {
          this.events.publish('audit:getAuditTimeline',auditId);
        },1000);
        
      }
      else if(key == 'submit_approval_admin'){
        
        //console.log("Submit Approval Admin");

        await this.afs.collection('audits').doc(auditId).collection('timeline').add({
          type:"info",
           message:this.lp.labels['AUDIT_SUBMITTED_FOR_VALIDATION_ADMIN'],
           key:'audit_submitted_validation_admin',
           user:{
             id:this.dataProvider.user && this.dataProvider.user.uid ? this.dataProvider.user.uid : null,
             name:this.dataProvider.user && this.dataProvider.user.name ? this.dataProvider.user.name : null
           },
           active:true,
           creationDate:new Date()
        });

        await this.afs.collection('audits').doc(auditId).collection('timeline').add({
          type:"sections",
          message:this.lp.labels['VALIDATE_AUDIT_MESSAGE'],
          key:'validate_audit_admin',
          role:'admin',
          active:true,
          creationDate:new Date()
  
        });

        await this.hideTimelineEvent(auditId,'submit_approval_admin'); 

       

        await this.afs.collection('audits').doc(auditId).update({'status.state':'validate_audit_admin','status.approver':1});


        this.http.post(CLOUD_FUNC_URL + 'sendApprovalMessages',{auditId:auditId,type:'admin'}).subscribe((res: any) => {
                    //console.log(res);
                    this.events.publish('audit:getAuditTimeline',auditId);

        },err => {
          //console.log("can't handle request");
          this.events.publish('audit:getAuditTimeline',auditId);
        });

      }
      else if(key == 'validate_audit_admin'){

        await this.afs.collection('audits').doc(auditId).collection('timeline').add({
          type:"action",
          message:this.lp.labels['VALIDATION_COMPLETED_MESSAGE'],
          btn_text:this.lp.labels['VALIDATION_COMPLETED_BTN'],
          key:'validation_completed',
          user:{
            id:this.dataProvider.user && this.dataProvider.user.uid ? this.dataProvider.user.uid : null,
            name:this.dataProvider.user && this.dataProvider.user.name ? this.dataProvider.user.name : null
          },
          active:true,
          creationDate:new Date()
  
        });


        await this.hideTimelineEvent(auditId,'validate_audit_admin'); 
      
       await this.afs.collection('audits').doc(auditId).update({'status.state':'validation_completed','status.approver':2});
  
       await this.afs.collection('audits').doc(auditId).collection('timeline').add({
        type:"approvers",
        message:this.lp.labels['SELECT_APPROVERS_MESSAGE'],
        key:'select_approvers',
        active:true,
        creationDate:new Date()
      });

      //  await this.afs.collection('audits').doc(auditId).collection('timeline').add({
              
      //     type:"info",
      //     message:this.lp.labels['AUDIT_COMPLETED_TIMELINE_MSG'],
      //     key:'audit_completed',
      //     user:{
      //       id:this.dataProvider.user && this.dataProvider.user.uid ? this.dataProvider.user.uid : null,
      //       name:this.dataProvider.user && this.dataProvider.user.name ? this.dataProvider.user.name : null
      //     },
      //     active:true,
      //     creationDate:new Date()

      //  });


      //   await this.afs.collection('audits').doc(auditId).collection('timeline').add({
      //         type:"action",
      //         message:this.lp.labels['AUDIT_REPORT_GENERATED_TIMELINE_MSG'],
      //         btn_text:this.lp.labels['VIEW_AUDIT_REPORT_TIMELINE_BTN'],
      //         key:'view_report',
      //         firstVisit:true,
      //         user:{
      //          id:this.dataProvider.user && this.dataProvider.user.uid ? this.dataProvider.user.uid : null,
      //          name:this.dataProvider.user && this.dataProvider.user.name ? this.dataProvider.user.name : null
      //         },
      //         active:true,
      //         creationDate:new Date()
      //   });

      //   await this.afs.collection('audits').doc(auditId).update({status:{id:2,name:'Completed',state:'audit_report_generated'}, completionDate:new Date()});

          setTimeout(() => {
              this.events.publish('audit:getAuditTimeline',auditId);
            },1000);
       }

       else if(key == 'select_approvers'){

          await this.afs.collection('audits').doc(auditId).collection('timeline').add({
              
              type:"info",
              message:this.lp.labels['AUDIT_SUBMITTED_FOR_APPROVALS'],
              key:'audit_approvals_submitted',
              user:{
                id:this.dataProvider.user && this.dataProvider.user.uid ? this.dataProvider.user.uid : null,
                name:this.dataProvider.user && this.dataProvider.user.name ? this.dataProvider.user.name : null
              },
              active:true,
              creationDate:new Date()

          });


          await this.afs.collection('audits').doc(auditId).collection('timeline').add({
            type:"approvers",
            message:this.lp.labels['UPDATE_APPROVERS_MESSAGE'],
            key:'update_approvers',
            role:'admin',
            active:true,
            creationDate:new Date()
          });

          await this.afs.collection('audits').doc(auditId).collection('timeline').add({
            type:"sections",
            message:this.lp.labels['APPROVE_AUDIT_MESSAGE'],
            key:'approve_audit',
            role:'approver',
            active:true,
            creationDate:new Date()
    
          });


          await this.hideTimelineEvent(auditId,'select_approvers'); 
          
         
          
          await this.afs.collection('audits').doc(auditId).update({'status.state':'approve_audit','status.approver':2});
          setTimeout(() => {
            this.events.publish('audit:getAuditTimeline',auditId);
          },1000);
          this.http.post(CLOUD_FUNC_URL + 'sendApprovalMessages',{auditId:auditId,type:'approver'}).subscribe((res: any) => {
                      //console.log(res);
                      this.events.publish('audit:getAuditTimeline',auditId);

          },err => {
            //console.log("can't handle request");
            this.events.publish('audit:getAuditTimeline',auditId);
          });


       }
       else if(key == 'approve_audit'){

        let currentApprover:any = {};
        const audit:any = await this.afs.collection('audits').doc(auditId).valueChanges().pipe(first()).toPromise();
        let isCompleted = true;
        if(audit.approvers){
          audit.approvers.forEach((approver,index) => {
            if(approver.aid == this.dataProvider.user.uid){
              audit.approvers[index]['completed'] = true;
              currentApprover = approver;
            }
            if(!audit.approvers[index]['completed']){
              isCompleted = false;
            }
          });

          await this.afs.collection('audits').doc(auditId).update({
            approvers:audit.approvers
          });
          
        }



        await this.afs.collection('audits').doc(auditId).collection('timeline').add({
          type:"action",
          message:this.lp.labels['AUDIT_APPROVAL_COMPLETED_MSG']+' '+currentApprover.name+' ('+currentApprover.designation+')',
          btn_text:this.lp.labels['APPROVAL_COMPLETED_BTN'],
          key:'approval_completed',
          user:{
            id:this.dataProvider.user && this.dataProvider.user.uid ? this.dataProvider.user.uid : null,
            name:this.dataProvider.user && this.dataProvider.user.name ? this.dataProvider.user.name : null
          },
          active:true,
          creationDate:new Date()
  
        });


        await this.hideTimelineEvent(auditId,'approve_audit'); 

       

        if(isCompleted){
                   await this.afs.collection('audits').doc(auditId).collection('timeline').add({
                  
              type:"info",
              message:this.lp.labels['AUDIT_COMPLETED_TIMELINE_MSG'],
              key:'audit_completed',
              user:{
                id:this.dataProvider.user && this.dataProvider.user.uid ? this.dataProvider.user.uid : null,
                name:this.dataProvider.user && this.dataProvider.user.name ? this.dataProvider.user.name : null
              },
              active:true,
              creationDate:new Date()

           });


            await this.afs.collection('audits').doc(auditId).collection('timeline').add({
                  type:"action",
                  message:this.lp.labels['AUDIT_REPORT_GENERATED_TIMELINE_MSG'],
                  btn_text:this.lp.labels['VIEW_AUDIT_REPORT_TIMELINE_BTN'],
                  key:'view_report',
                  firstVisit:true,
                  user:{
                   id:this.dataProvider.user && this.dataProvider.user.uid ? this.dataProvider.user.uid : null,
                   name:this.dataProvider.user && this.dataProvider.user.name ? this.dataProvider.user.name : null
                  },
                  active:true,
                  creationDate:new Date()
            });

            await this.afs.collection('audits').doc(auditId).update({status:{id:2,name:'Completed',state:'audit_report_generated'}, completionDate:new Date()});

            setTimeout(() => {
              this.events.publish('audit:getAuditTimeline',auditId);
            },1000);
        }
        else{

          await this.afs.collection('audits').doc(auditId).collection('timeline').add({
              
            type:"info",
            message:this.lp.labels['AUDIT_SUBMITTED_FOR_OTHER_APPROVALS'],
            key:'audit_approvals_other_submitted',
            user:{
              id:this.dataProvider.user && this.dataProvider.user.uid ? this.dataProvider.user.uid : null,
              name:this.dataProvider.user && this.dataProvider.user.name ? this.dataProvider.user.name : null
            },
            active:true,
            creationDate:new Date()

        });
          
          await this.afs.collection('audits').doc(auditId).collection('timeline').add({
            type:"sections",
            message:this.lp.labels['APPROVE_AUDIT_MESSAGE'],
            key:'approve_audit',
            role:'approver',
            active:true,
            creationDate:new Date()
          });
          await this.afs.collection('audits').doc(auditId).update({status:{id:1,name:'In Progress',state:'approve_audit','approver':2}});
          setTimeout(() => {
            this.events.publish('audit:getAuditTimeline',auditId);
          },1000);
        }

       }

       

    }

   async askForActionPlan(auditId,timelineId){

      await this.afs.collection('audits').doc(auditId).collection('timeline').add({
                type:"start_action_plan",
                message:this.lp.labels['ACTION_PLAN_CONTNIUE_TIMELINE_QUE'],
                key:'start_action_plan',
                user:{
                  id:this.dataProvider.user && this.dataProvider.user.uid ? this.dataProvider.user.uid : null,
                  name:this.dataProvider.user && this.dataProvider.user.name ? this.dataProvider.user.name : null
                },
                active:true,
                creationDate:new Date()
      });

     await this.afs.collection('audits').doc(auditId).collection('timeline').doc(timelineId).update({
      firstVisit:false
     });

    setTimeout(() => {
          this.events.publish('audit:getAuditTimeline',auditId);
    },1000);

    }


    async startActionPlan(auditId,timelineId, actionIssues){
       await this.afs.collection('audits').doc(auditId).collection('timeline').doc(timelineId).update({
        active:false
       });
       await this.afs.collection('audits').doc(auditId).collection('timeline').add({
             type:"action-plan",
              message:this.lp.labels['ACTION_PLAN_CREATED_TIMELINE_MSG'],
              key:'action_plan_created',
              user:{
                id:this.dataProvider.user && this.dataProvider.user.uid ? this.dataProvider.user.uid : null,
                name:this.dataProvider.user && this.dataProvider.user.name ? this.dataProvider.user.name : null
              },
              active:true,
              creationDate:new Date()

        });
        await this.afs.collection('audits').doc(auditId).update({'status.state':'action_plan_created'});

         setTimeout(() => {
                this.events.publish('audit:getAuditTimeline',auditId);
          },1000);
    }

    async completeAudit(auditId, timelineId){

          await this.afs.collection('audits').doc(auditId).collection('timeline').doc(timelineId).update({
           active:false
          });

         await this.afs.collection('audits').doc(auditId).collection('timeline').add({
              
              type:"info",
              message:this.lp.labels['AUDIT_COMPLETED_TIMELINE_MSG'],
              key:'audit_completed',
              user:{
                id:this.dataProvider.user && this.dataProvider.user.uid ? this.dataProvider.user.uid : null,
                name:this.dataProvider.user && this.dataProvider.user.name ? this.dataProvider.user.name : null
              },
              active:true,
              creationDate:new Date()

          });

         await this.afs.collection('audits').doc(auditId).update({status:{id:2,name:'Completed',state:'audit_completed'}, completionDate:new Date()});

           setTimeout(() => {
              this.events.publish('audit:getAuditTimeline',auditId);
            },1000);


    }


   async saveSigns(auditId, signs){    

     let signUrls = [];
     await Promise.all(
      
      signs.map(async (sign,index) => {
          
           const path = 'audits/'+auditId+'/signature/'+index+'/'+auditId+'.png';
          
           const imgRef = this.fbStorage.ref(path);

           await imgRef.putString(sign.data,'data_url');

           const downloadURL = await imgRef.getDownloadURL().pipe(first()).toPromise();

           signUrls[index] = {path:path,url:downloadURL};
           
     }));

    

     await this.afs.collection('audits').doc(auditId).update({signs:signUrls});

     await this.afs.collection('audits').doc(auditId).collection('timeline').add({
              type:"signatures",
              message:this.lp.labels['SIGNATURES_TIMELINE_MSG'],
              key:'signatures_done',
              user:{
                id:this.dataProvider.user && this.dataProvider.user.uid ? this.dataProvider.user.uid : null,
                name:this.dataProvider.user && this.dataProvider.user.name ? this.dataProvider.user.name : null
              },
              active:true,
              creationDate:new Date()

      });

      await this.afs.collection('audits').doc(auditId).collection('timeline').add({
        type:"action",
        message:this.lp.labels['SUBMIT_VALIDATION_ADMIN_MESSAGE'],
        btn_text:this.lp.labels['SUBMIT_VALIDATION_ADMIN_BTN'],
        key:'submit_approval_admin',
        user:{
          id:this.dataProvider.user && this.dataProvider.user.uid ? this.dataProvider.user.uid : null,
          name:this.dataProvider.user && this.dataProvider.user.name ? this.dataProvider.user.name : null
        },
        active:true,
        creationDate:new Date()

      });
    
     await this.afs.collection('audits').doc(auditId).update({'status.state':'submit_approval_admin'});

     await this.hideTimelineEvent(auditId,'get_signatures'); 
            
     setTimeout(() => {
              this.events.publish('audit:getAuditTimeline',auditId);
     },1000);

      this.audits.forEach(audit => {
              this.events.publish('audit:auditDetails',audit.id,audit);
      });

   }

    


    async saveSignature(auditId, signature){

           const path = 'audits/'+auditId+'/signature/'+auditId+'.png';
           const imgRef = this.fbStorage.ref(path);

           await imgRef.putString(signature,'data_url');

           const downloadURL = await imgRef.getDownloadURL().pipe(first()).toPromise();

           await this.afs.collection('audits').doc(auditId).update({signature:{path:path,url:downloadURL}});

           await this.hideTimelineEvent(auditId,'get_signoff');

           await this.afs.collection('audits').doc(auditId).collection('timeline').add({
              type:"signoff",
              message:this.lp.labels['SIGNOFF_TIMELINE_MSG'],
              key:'signoff_done',
              user:{
                id:this.dataProvider.user && this.dataProvider.user.uid ? this.dataProvider.user.uid : null,
                name:this.dataProvider.user && this.dataProvider.user.name ? this.dataProvider.user.name : null
              },
              active:true,
              creationDate:new Date()

          });

          await this.afs.collection('audits').doc(auditId).collection('timeline').add({
              
              type:"info",
              message:this.lp.labels['AUDIT_COMPLETED_TIMELINE_MSG'],
              key:'audit_completed',
              user:{
                id:this.dataProvider.user && this.dataProvider.user.uid ? this.dataProvider.user.uid : null,
                name:this.dataProvider.user && this.dataProvider.user.name ? this.dataProvider.user.name : null
              },
              active:true,
              creationDate:new Date()

          });

            await this.afs.collection('audits').doc(auditId).collection('timeline').add({
              type:"action",
              message:this.lp.labels['ACTION_REPORT_GENERATED_TIMELINE_MSG'],
              btn_text:this.lp.labels['VIEW_ACTION_REPORT_TIMELINE_BTN'],
              key:'view_action_report',
              user:{
                id:this.dataProvider.user && this.dataProvider.user.uid ? this.dataProvider.user.uid : null,
                name:this.dataProvider.user && this.dataProvider.user.name ? this.dataProvider.user.name : null
              },
              active:true,
              creationDate:new Date()
            });

          await this.afs.collection('audits').doc(auditId).update({status:{id:2,name:'Completed',state:'audit_completed'}, completionDate:new Date()});

           setTimeout(() => {
              this.events.publish('audit:getAuditTimeline',auditId);
            },1000);

          this.audits.forEach(audit => {
              this.events.publish('audit:auditDetails',audit.id,audit);
          });


    }

    async verifyActionPlan(auditId,actionIssues){

        await this.afs.collection('audits').doc(auditId).collection('timeline').add({
             type:"action-plan",
              message:this.lp.labels['ACTION_PLAN_VERIFIED_TIMELINE_MSG'],
              key:'action_plan_verified',
              user:{
                id:this.dataProvider.user && this.dataProvider.user.uid ? this.dataProvider.user.uid : null,
                name:this.dataProvider.user && this.dataProvider.user.name ? this.dataProvider.user.name : null
              },
              active:true,
              creationDate:new Date()

        });
        await this.afs.collection('audits').doc(auditId).collection('timeline').add({
          type:"action",
          message:this.lp.labels['COMPLETE_ACTION_PLAN_TIMELINE_QUE'],
          btn_text:this.lp.labels['COMPLETE_ACTION_PLAN_TIMELINE_BTN'],
          key:'complete_action_plan',
          user:{
            id:this.dataProvider.user && this.dataProvider.user.uid ? this.dataProvider.user.uid : null,
            name:this.dataProvider.user && this.dataProvider.user.name ? this.dataProvider.user.name : null
          },
          active:true,
          creationDate:new Date()
       });

        await this.hideTimelineEvent(auditId,'action_plan_created'); 
        await this.afs.collection('audits').doc(auditId).update({'status.state':'complete_action_plan'});
         setTimeout(() => {
          this.events.publish('audit:getAuditTimeline',auditId);
        },1000);
    }

    async getQueDetails(typeId,sectionId,queId){
        const queDetails = await this.afs.collection('audtypes').doc(typeId).collection('sections').doc(sectionId).collection('questions').doc(queId).valueChanges().pipe(first()).toPromise();
        this.events.publish('audit:queDetails',queDetails);
    }
    async getSectionFields(typeId,sectionId){

        const sectionFields = await this.afs.collection('audtypes').doc(typeId).collection('sections').doc(sectionId).collection('fields',ref => ref.orderBy('order').where('active', '==', true)).snapshotChanges().pipe(
                  map(actions => actions.map(a => {
                      const data = a.payload.doc.data() as any;
                    const id = a.payload.doc.id;
                  
                    return { id, ...data };
        }))).pipe(first()).toPromise();

        //console.log("fields");
        //console.log(sectionFields);
        this.events.publish('audit:sectionFields',sectionFields);
    }

    async getPriorityList(){
      
      const list = await this.afs.collection('config').doc("audit").collection('priority',ref => ref.orderBy('order')).snapshotChanges().pipe(
                  map(actions => actions.map(a => {
                    const data = a.payload.doc.data() as any;
                     const id = a.payload.doc.id;
                    return { id, ...data };
      }))).pipe(first()).toPromise();
      
      this.events.publish('audit:priorityList',list);
      
    }

    async generateAuditReportPdf(auditId,sections, generateGraphs){
      if(generateGraphs && sections && sections.length > 0){
        for(var i=0; i< sections.length;i++){
             const path = 'audits/'+auditId+'/graphs/'+sections[i]['id']+'.png';
             const imgRef = this.fbStorage.ref(path);

             await imgRef.putString(sections[i]['data'],'data_url');

             const downloadURL = await imgRef.getDownloadURL().pipe(first()).toPromise();

             await this.afs.collection('audits').doc(auditId).collection('graphs').doc(sections[i]['id']).set({url:downloadURL});

        }
      }
      if(auditId){
        //console.log('auditId', auditId);
        //console.log('audit service--------');
        await this.afs.collection('reports').doc(auditId).set({status:'pending', createdAt: new Date(), auditId: auditId});
      }
      
    }

    async getAuditReportPdf(auditId){
      //console.log('getAuditReportPdf- audit id', auditId)
        const report:any = await this.afs.collection('reports').doc(auditId).valueChanges().pipe(first()).toPromise();
        const link = report && report.url ? report.url : undefined;
        //console.log('link',link);
        //console.log('auditId', auditId)
        this.events.publish('audit:auditReportPdf',link);
    }

    async getProjects(){
        const projects = await this.afs.collection('projects',ref => ref.orderBy('startDate').where('active','==',true)).snapshotChanges().pipe(
                  map(actions => actions.map(a => {
                    const data = a.payload.doc.data() as any;
                    const id = a.payload.doc.id;

                    if(data.startDate){
                      data['startDate'] = data.startDate.toDate();
                    }
                    if(data.endDate){
                      data['endDate'] = data.endDate.toDate();
                    }

                    return { id, ...data };
       }))).pipe(first()).toPromise();

      this.events.publish('audit:projects',projects);
    }

    async getProjectDealers(projectId){
        const dealers = await this.afs.collection('projects').doc(projectId).collection('dealers',ref => ref.orderBy('audits','desc')).snapshotChanges().pipe(
                  map(actions => actions.map(a => {
                    const data = a.payload.doc.data() as any;
                    const id = a.payload.doc.id;
                    return { id, ...data };
       }))).pipe(first()).toPromise();

       this.events.publish('audit:projectDealers',dealers);
    }

    async getProjectDealerAudits(projectId, dealer){

      const audits = await this.afs.collection('projects').doc(projectId).collection('dealers').doc(dealer.id).collection('audits').snapshotChanges().pipe(
                  map(actions => actions.map(a => {
                    const data = a.payload.doc.data() as any;
                    const id = a.payload.doc.id;
                    return { id, ...data };
       }))).pipe(first()).toPromise();

       this.events.publish('audit:projectDealerAudits',audits, dealer);
    }

    async getProject(projectId){
        const project:any = await this.afs.collection('projects').doc(projectId).valueChanges().pipe(first()).toPromise();
        project.id = projectId;
         if(project.startDate){
                      project['startDate'] = project.startDate.toDate();
         }
         if(project.endDate){
                      project['endDate'] = project.endDate.toDate();
          }
       
        this.events.publish('audit:project',project);
    }

    async getRatings(){
        const ratings:any = await this.afs.collection('config').doc("rating").valueChanges().pipe(first()).toPromise();
       
        this.events.publish('audit:ratings',ratings);
    }

    async getAdminApprovalAudits(){
      let adminApprovalAudits = await this.afs.collection('audits',ref => ref.where('status.approver', '>', 0)).snapshotChanges().pipe(
        map(actions => actions.map(a => {
          const data = a.payload.doc.data() as any;
          const id = a.payload.doc.id;
          if(data.schedule && data.schedule.start && data.schedule.start.date){
            data['schedule']['start']['date'] = data.schedule.start.date.toDate();
          }
          if(data.schedule && data.schedule.end && data.schedule.end.date){
            data['schedule']['end']['date'] = data.schedule.end.date.toDate();
          }
          if(data.completionDate){
            data.completionDate = data.completionDate.toDate();
          }
          return { id, ...data };
          }))).pipe(first()).toPromise();

          this.events.publish('audit:adminApprovalAuditsList',adminApprovalAudits);
    }

    async recordAuditChanges(auditId, approval, data){
      const oldChanges = await this.afs.collection('audits').doc(auditId).collection('approval').doc(approval).collection('changes',ref => ref.where('queId','==',data.queId).where('sectionId','==',data.sectionId).where('change','==',data.change)).snapshotChanges().pipe(
        map(actions => actions.map(a => {
          const data = a.payload.doc.data() as any;
                const id = a.payload.doc.id;
                if(data.createdAt){
                  data.createdAt = data.createdAt.toDate();
                }
                return { id, ...data };
      }))).pipe(first()).toPromise();

      let changes = {createdAt:new Date(), ...data}
      if(oldChanges && oldChanges.length > 0){
        if(data && data.change == 'comment'){
          
            if(data.newComment && oldChanges[0].oldComment && data.newComment.trim() == oldChanges[0].oldComment.trim()){
             
              await this.afs.collection('audits').doc(auditId).collection('approval').doc(approval).collection('changes').doc(oldChanges[0]['id']).delete();
            }
            else{
              await this.afs.collection('audits').doc(auditId).collection('approval').doc(approval).collection('changes').doc(oldChanges[0]['id']).update({
                createdAt:new Date(),
                newComment:data.newComment
              });
            }
           
        }
        else if(data && data.change == 'rating'){
         
          if(data.newRating == oldChanges[0].oldRating){
           
            await this.afs.collection('audits').doc(auditId).collection('approval').doc(approval).collection('changes').doc(oldChanges[0]['id']).delete();
          }
          else{
            await this.afs.collection('audits').doc(auditId).collection('approval').doc(approval).collection('changes').doc(oldChanges[0]['id']).update({
              createdAt:new Date(),
              newRating:data.newRating
            });
          }
        
        }
        else if(data && data.change == 'evidence'){
          await this.afs.collection('audits').doc(auditId).collection('approval').doc(approval).collection('changes').doc(oldChanges[0]['id']).update(changes);
        }
      }
      else{
        await this.afs.collection('audits').doc(auditId).collection('approval').doc(approval).collection('changes').add(changes);
      }
     
    }

    async getApprovalChanges(auditId, approval){
      const changes = await this.afs.collection('audits').doc(auditId).collection('approval').doc(approval).collection('changes',ref => ref.orderBy('createdAt','desc')).snapshotChanges().pipe(
        map(actions => actions.map(a => {
          const data = a.payload.doc.data() as any;
                const id = a.payload.doc.id;
                if(data.createdAt){
                  data.createdAt = data.createdAt.toDate();
                }
                return { id, ...data };
      }))).pipe(first()).toPromise();

      this.events.publish('audit:approvalChanges',changes);
    }

    async startAuditApproval(auditId,approver){
      if(this.dataProvider.user.uid){
        await this.afs.collection('audits').doc(auditId).update({
          'status.currentApprover' :  this.dataProvider.user.uid
        });
        
        let auditorName = this.dataProvider.user && this.dataProvider.user.name ? this.dataProvider.user.name : '';
        await this.afs.collection('audits').doc(auditId).collection('timeline').add({
              
          type:"info",
          message:this.lp.labels['AUDIT_APPROVAL_STARTED_BY']+' '+auditorName+' ('+approver.designation+')',
          key:'audit_approval_started',
          user:{
            id:this.dataProvider.user && this.dataProvider.user.uid ? this.dataProvider.user.uid : null,
            name:this.dataProvider.user && this.dataProvider.user.name ? this.dataProvider.user.name : null
          },
          active:true,
          creationDate:new Date()

       });

        this.events.publish('audit:approvalStarted');
      }
      else{
        this.events.publish('audit:approvalNotStarted');
      }
     
    }
}




// WEBPACK FOOTER //
// ./src/providers/audit/audit.ts